import { SUPERADMINRECRUITERLOCATIONLIST } from "../../ENVIRONMENT";
// api for location
function recruiterListLocation(token) {
  const response = fetch(SUPERADMINRECRUITERLOCATIONLIST, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { recruiterListLocation };
